<template>
    <div>
        <section class="page-content center">
            <br>
            <v-layout row wrap>
                <v-flex xs12 sm12 lg12>
                    <p class="total" v-if="confirmado">{{msmTitulo}}</p>
                    <p class="total" style="color:#D64550" v-else>{{msmTitulo}}</p>    
                    <v-container class="resumo">
                        <p >{{msgCorpo}}</p>
					</v-container>
                </v-flex>
                <v-flex xs12 sm12 lg12>
                    <p class="form-titulo">Minuta do Contrato</p>
                </v-flex>
                <v-flex xs12 sm12 md12 lg8>
                    <iframe v-if="this.$vuetify.breakpoint.lg" :src="`${exibeContrato}`" width="680" height="400" style="border: none;"></iframe>
                </v-flex>
                <v-flex xs12 sm12 md12 lg4>
					<div v-for="item in pdfSelecionado" :key="item.link">
						<div class="hidden-md-and-down">
							<v-list-tile @click="exibeContrato = item.link" avatar>
								<v-list-tile-action>
									<img src="../Content/images/pdf.png" width="30px">
								</v-list-tile-action>
								<v-list-tile-title>{{item.nome.substring(5, 30)}}</v-list-tile-title>
							</v-list-tile>
						</div>
						<div class="hidden-lg-and-up">
							<v-list-tile @click="exibeContrato = item.link" :href="item.link" target='_blank' avatar>
								<v-list-tile-action>
									<img src="../Content/images/pdf.png" width="30px">
								</v-list-tile-action>
								<v-list-tile-title>{{item.nome.substring(5, 30)}}</v-list-tile-title>
							</v-list-tile>
						</div>
					</div>
                </v-flex>
                <v-flex xs12 sm12 lg4 v-if="this.company.status != 'AGUARDANDO CONFIRMAÇÃO'">
                    <div class="planos-wrapper" style="background:none">
                        <div class="list-planos">
                            <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                <br>
                                <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Proposta com status: {{this.company.status}}</h6>
                            </div>
                        </div>
                    </div>
                </v-flex>
                <v-flex xs12 sm12 lg12 v-else>
                    <v-flex xs12 sm12 lg4 v-if="this.company.reteveAdesao == true">
                        <v-flex xs12 sm3 md12 lg12>
                            <v-checkbox v-model="contrataccept" color="#8395A7">
                                <span slot="label">Li e concordo com os termos do contrato</span>
                            </v-checkbox>
                        </v-flex>
                        <div class="planos-wrapper" style="background:none">
                            <div class="list-planos">                    
                                <div class="item">
                                    <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                    <br>
                                    <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                                    <br>
                                    <h6 class="desconto" style="text-align: center;">Adesão</h6>
                                    <a @click="aceiteProposta()" class="button">Aceitar Proposta</a>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="!boletoGerado">
                        <v-flex xs12 sm3 md12 lg12>
                            <v-checkbox v-model="contrataccept" color="#8395A7">
                                <span slot="label">Li e concordo com os termos do contrato</span>
                            </v-checkbox>
                        </v-flex>
                        <div class="planos-wrapper" style="background:none">
                            <div class="list-planos">                    
                                <div class="item">
                                    <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                    <br>
                                    <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                                    <br>
                                    <h6 class="desconto">Adesão</h6>
                                    <a @click="gerarBoleto()" class="button">Gerar Boleto</a>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="imprimir">
                        <div class="planos-wrapper" style="background:none">
                            <div class="list-planos">                    
                                <div class="item">
                                    <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                    <br>
                                    <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                                    <br>
                                    <h6 class="desconto">Adesão</h6>
                                    <a @click="imprimirBoleto()" class="button">Imprimir Boleto</a>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>  
            <br>
            <br>
            <br>
            <br> 
        </section>
        <loading :active.sync="isLoading" :can-cancel="true" color="#7593b4" :is-full-page="fullPage"></loading>
        <Snackbar ref=chamaSnackbar />
    </div>
</template>
<script>
    import Snackbar from '../components/snackbar.vue'
    import axios from 'axios'
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { baseApiUrl, modelBoleto } from '@/global'
    import moment from 'moment'
    export default {
        components: {Snackbar, Loading},
        data() {
            return {
                msmTitulo: 'Estamos quase lá!',
                msgCorpo: 'Para concluir a sua proposta, é necessário gerar o boleto. Para isso, basta clicar no botão abaixo e aguardar. ' ,
                confirmado: true,
                company: [],
                boletoGerado: false,
                planosSelecionados: {},
                pdfSelecionado: [],
                exibeContrato: '',
                contrataccept: false,
                cidade: '',
                estado: '',
                bairro: '',
                fullPage: true,  
                isLoading: false, 
                token: '',
                idBoleto: '', 
                imprimir: false,
                ipConfirm: '',
                confirmDate: '',
            }
        },

        mounted : function() {
            localStorage.clear()
            sessionStorage.clear()
            this.pegaParametrosUrl()
            this.carregaPlano()
        },

        methods: {
            async carregaPlano() {
                try {
                    let res = await axios.get(`${baseApiUrl}PrecoPlanos?filter={"where":{"companyId":"${this.company.id}"},"include":"plans"}`)
                    if (res.data != '') {
                        this.planosSelecionados = res.data
						this.exibeContrato = res.data[0].plans.urlMinutaContrato
                        for (let i = 0; i < res.data.length; i++) {
                            this.pdfSelecionado.push({
                                nome: res.data[i].plans.name,
                                link: res.data[i].plans.urlMinutaContrato
                            })
                        }
                    }
                } catch (error) {
                    this.isLoading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar plano", "ERRO");
                }
            },

            async gerarBoleto() {
                let vm = this
                if (this.contrataccept) {
                    this.company.proposalNumber = this.company.id.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
                    this.isLoading = true
                    this.token = ''
                    this.idBoleto = ''            
                    //Criando data de vencimeto do boleto
                    var datapagvenc = new Date();
                    datapagvenc.setDate(new Date().getDate() + 3)
                    //Preencher o campos do model de Boleto
                    modelBoleto.pagadorDocumentoNumero = this.company.cnpj.replace(/[^\d]+/g,'')
                    modelBoleto.pagadorNome = this.company.businessName.substr(0, 39)
                    modelBoleto.pagadorEndereco = this.company.address.substr(0, 33) + ', ' + this.company.addressNumber
                    modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
                    modelBoleto.pagadorDocumentoTipo = 2
                    modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
                    modelBoleto.pagadorUf = this.estado 
                    modelBoleto.pagadorCep = this.company.cep.replace(/[^\d]+/g,'');
                    //modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
                    try {
                        var dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
                        let res = await axios.get(`${baseApiUrl}FormOfPayments?filter={"where":{"and":[{"dayInclusion":{"inq":[${dayInclusion}]}},{"type":"REGRA"}]}}`)
                        if(res.data != '') {
                            if (parseInt(res.data[0].dueDate) < parseInt(moment().format('DD'))) {
                                modelBoleto.dataVencimento = moment().add(1, 'M').format('YYYY-MM-') + res.data[0].dueDate
                            } else {
                                modelBoleto.dataVencimento = moment().format('YYYY-MM-') + res.data[0].dueDate
                            }
                        } else {
                            this.isLoading = false
                            vm = this;
                            vm.$refs.chamaSnackbar.snack("#EF5350","Data de vencimento não localizada","DESCULPE");
                            this.close()
                        }
                    } catch (error) {
                        this.isLoading = false
                        vm.$refs.chamaSnackbar.snack("#EF5350","Data de vencimento não localizada.","DESCULPE");
                        this.close()
                    }
                    modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
                    //salvando o responsibility e o valor do boleto caso seja anual
                    modelBoleto.valorNominal = parseFloat(this.company.responsibility)
                    modelBoleto.mensagem = 'Boleto referente ao plano empresarial'        
                    modelBoleto.nsu = this.company.proposalNumber
                    modelBoleto.nossoNumero = parseInt(this.company.proposalNumber +Math.floor(10 + Math.random() * 99))
                    modelBoleto.seuNumero = this.company.proposalNumber +Math.floor(10 + Math.random() * 99)
            
                    //Gerando o Boleto e pegando o ID
                    try {
                        let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
                        if(res.data != '') {
                            this.idBoleto = res.data.id
                            this.imprimirBoleto()
                        }              
                    } catch (error) {
                        this.isLoading = false
                        vm = this;
                        vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
                        this.close()                 
                        }
                } else {
                    this.isLoading = false
                    vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário concordar com os termos do contrato!","ATENÇÃO");
                }
            },

            async aceiteProposta() {
                if (this.contrataccept) {
                    try {
                        this.isLoading = true
                        await this.pegaDadosConfirmacao()
                        let envio = {
                            "salesmanIPConfirm": this.ipConfirm,
                            "companyIPConfirm": this.ipConfirm,
                            "salesmanConfirm": this.confirmDate,
                            "companyConfirm": this.confirmDate,
                            "status": "EM VALIDAÇÃO"
                        }
                        await axios.post(`${baseApiUrl}Companies/upsertWithWhere?[where][id]=${this.company.id}`, envio).then(() => {
                            this.isLoading = false
                            vm = this;
                            vm.$refs.chamaSnackbar.snack("#51D400","Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Odontobase a dar andamento na proposta ao Contrato Coletivo Empresarial.","Proposta confirmada com Sucesso!") 
                        })
                        .catch(() => {
                            var vm = this;
                            vm.$refs.chamaSnackbar.snack("#F9A825","Você pode tentar confirmar novamente ou entrar em contato com a Odontobase.","Algo deu errado na confirmação da proposta!")
                        })
                    } catch (error) {
                        var vm = this;
                        vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao aceitar proposta. Por favor, tente novamente","ATENÇÃO")
                    }
                } else {
                    this.isLoading = false
                    vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Para aceitar a proposta, é necessário concordar com os termos do contrato!","ATENÇÃO");
                }
            },
                
            async imprimirBoleto() {
                this.isLoading = true
                await this.pegaDadosConfirmacao()
                //Baixando Boleto PDF
                try {
                    let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.idBoleto}/imprimir`,{ responseType: 'arraybuffer', headers: {
                            Authorization: 'Bearer ' + this.token, //the token is a variable which holds the token           
                            'Content-type': 'application/pdf'
                        }
                    })
                    if (res.data != null) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [res.data], 
                            {type: 'application/pdf'}
                        );
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        const link = document.createElement('a');
                        link.href = fileURL;
                        link.setAttribute('download', 'boleto.pdf'); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        //Open the URL on new Window
                        window.open(fileURL);
                        if (!this.boletoGerado) {
                            this.boletoGerado = true
                            this.msmTitulo = 'Proposta confirmada com Sucesso!'
                            this.msgCorpo = 'Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Oral Santa Helena a dar andamento na proposta ao Contrato Coletivo Empresarial.'
                            this.atualizaCompany()
                        } else {
                            this.imprimir = false
                            this.msmTitulo = 'Boleto impresso com Sucesso!'
                            this.msgCorpo = 'Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Oral Santa Helena a dar andamento na proposta ao Contrato Coletivo Empresarial.'  
                        }
                        this.isLoading = false
                    }              
                } catch (error) {
                    this.isLoading = false
                    var vm = this;            
                    vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir Boleto, tente novamente ou entre em contato com a Oral Santa Helena!","ERRO");
                    this.close()                 
                }
            },

            async pegaDadosConfirmacao() {
                //coleta IP, data e hora da confirmação do cliente    
                try {
                    let res = await axios.get(`https://api.ipify.org/?format=json`)
                    if (res.data != null) {
                        this.ipConfirm = res.data.ip
                    } else {
                        this.ipConfirm = '127.0.0.0'
                    }
                } catch (error) {
                    this.ipConfirm = '127.0.0.0'
                }
                this.confirmDate = new Date().toISOString()
            },

            async pegaParametrosUrl() {
                var params = window.location.search.substring(1).split('?');
                if (params[0] != '') {
                    //Criar objeto que vai conter os parametros
                    var paramArray = {};

                    //Passar por todos os parametros
                    for(var i=0; i<params.length; i++) {
                        //Dividir os parametros chave e valor
                        var param = params[i].split('=');

                        //Adicionar ao objeto criado antes
                        paramArray[param[0]] = param[1];
                    }
                    if (paramArray['cp']) {
                        await axios.get(`${baseApiUrl}Companies?filter[where][id]=${paramArray['cp']}`).then(res => { 
                            if (res.data != null) {
                                this.company = res.data[0]
                                if (this.company.situacaoBoleto == "" || this.company.situacaoBoleto == "VENCIDO" || this.company.situacaoBoleto == undefined) {
                                    this.retornoViaCEP()
                                    this.confirmado = true 
                                } else if(this.company.situacaoBoleto == "PAGO") {
                                    this.confirmado = true
                                    this.boletoGerado = true
                                    this.msmTitulo = 'Pagamento detectado!'
                                    this.msgCorpo = 'Olá, detectamos que você já efetuou o pagamento do boleto. Entre em contato com a Oral Santa Helena para mais informações.'
                                } else if(this.company.situacaoBoleto == "BAIXADO") {
                                    this.confirmado = true
                                    this.boletoGerado = true
                                    this.msmTitulo = 'Boleto Baixado!'
                                    this.msgCorpo = 'Olá, o boleto para essa proposta encontra-se baixado. Para mais informações, entre em contato com a Oral Santa Helena.'
                                } else if(this.company.situacaoBoleto == "REGISTRADO" || this.company.situacaoBoleto == "GERADO") {
                                    this.msmTitulo = 'Boleto disponível!'
                                    this.msgCorpo = 'Olá, já existe um boleto gerado para a sua proposta, clique abaixo para imprimir.'
                                    this.confirmado = true
                                    this.imprimir = true
                                    this.boletoGerado = true
                                    this.idBoleto = this.company.boletoId
                                    //this.imprimirBoleto()
                                }
                            }
                            this.carregaPlano()
                        })
                        .catch(() => {
                            this.confirmado = false
                            this.msmTitulo = 'Algo deu errado na confirmação da proposta!'
                            this.msgCorpo = 'Você pode tentar confirmar novamente ou entrar em contato com a Oral Santa Helena.'
                        })
                    }
                }
            },

            async atualizaCompany() {
                let envio = {
                    "salesmanIPConfirm": this.ipConfirm,
                    "companyIPConfirm": this.ipConfirm,
                    "salesmanConfirm": this.confirmDate,
                    "companyConfirm": this.confirmDate,
                    "boletoId": this.idBoleto,
                    "situacaoBoleto": "GERADO",
                    "nossoNumero": modelBoleto.nossoNumero,
                    "status": "EM VALIDAÇÃO"
                }
                try {
                    await axios.post(`${baseApiUrl}Companies/update?[where][id]=${this.company.id}`, envio)
                } catch (error) {
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao atualizar situação do boleto e empresa. Tente novamente","ATENÇÃO")                   
                }
            },

            async retornoViaCEP() {
                if (this.company.cep != '') {
                    try {
                        let res = await axios.get(`https://viacep.com.br/ws/${this.company.cep.replace(/[^\d]+/g,'')}/json/`) 
                        if (res.data) {
                            if (res.data.erro == "true" || !res.data.bairro || !res.data.localidade || !res.data.uf) {
                                this.retornoCEP()
                            } else {
                                this.cidade = res.data.localidade
                                this.estado = res.data.uf
                                this.bairro = res.data.bairro
                            }
                        } else {
                            var vmcep = this;
                            vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                            this.cidade = ''
                            this.estado = ''
                            this.bairro = ''
                        }
                    } catch (error) {
                        vmcep = this;
                        vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                        this.cidade = ''
                        this.estado = ''
                        this.bairro = ''
                    }
                }
            },

            async retornoCEP() {
                try {
                    let res = await axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.company.cep}) 
                    if (res.data != '') {
                        await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${res.data.IdUf}}}`).then(res2 => {
                            this.estado = res2.data[0].prefix
                            this.cidade = res.data.Municipio
                            this.bairro = res.data.Bairro
                        })
                    }            
                } catch (error) {
                    var vmcep = this;
                    vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                }         
            },
        }
    }
</script>

<style>
    .link {
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }

    .titulo {
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }

    .imagemcaarj {
        background: url('https://www.apvs.com.br/assets/uploads/parceiros/caarj.png')no-repeat;
        background-size: 500px;
    }
</style>